export const ROJO_NEGRO_ENDPOINTS = Object.freeze({
  history: '/rojonegro/report/ticket/history',
  details: '/rojonegro/report/ticket/details',
  export: '/export-rojonegro-history',
})

const COLOR_VARIANTS = {
  red: 'danger',
  black: 'dark',
}

export const rojoNegroSelectionBadges = (selections) =>
  (selections || []).map(({ race, color }) => {
    if (!COLOR_VARIANTS[color]) {
      return { text: `${race} ${color}`, variant: 'secondary' }
    }

    return {
      labelKey: `rojo_negro.chip.${color}`,
      titleKey: `rojo_negro.chip_title.${color}`,
      params: { race },
      variant: COLOR_VARIANTS[color],
    }
  })
